import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const getAllKbTags = createAsyncThunk(
  'kbTag/getAllKbTags',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const response = await axios.get(
        `${BASE_URL}/trustchat-backend-service/v1/kb/tag/${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
  /** After first successful load, refetches skip skeleton (stale list stays visible). */
  hasFetchedOnce: false,
};

const getAllKbTagsSlice = createSlice({
  name: 'getAllKbTags',
  initialState,
  reducers: {
    resetGetAllKbTagsState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
      state.hasFetchedOnce = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllKbTags.pending, (state) => {
        state.loading = !state.hasFetchedOnce;
        state.error = null;
        state.success = false;
      })
      .addCase(getAllKbTags.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.hasFetchedOnce = true;
        state.data = action.payload;
        // toast.success(action.payload.message || 'Tags fetched successfully.');
      })
      .addCase(getAllKbTags.rejected, (state, action) => {
        state.loading = false;
        state.hasFetchedOnce = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message || 'Failed to fetch tags.');
      });
  }
});

export const { resetGetAllKbTagsState } = getAllKbTagsSlice.actions;
export default getAllKbTagsSlice.reducer;